module.exports = __webpack_public_path__ + "img/video.49c38ca4.svg";